<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="card">
                    <div class="card-header">
                        {{$t('Implant crowns')}}
                    </div>
                    <div class="card-body">
                        <b-form-group class="mt-2">
                            <b-form-radio-group v-model="innerToothOptions.implantCrownOption"
                                                :options="implantCrownOptions"
                                                :required="false">

                            </b-form-radio-group>
                        </b-form-group>
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg mb-3 mb-lg-0">
                                <b-form-input :placeholder="$t('System name')"
                                                v-model="innerToothOptions.systemName" type="text"
                                                list="cars"></b-form-input>
                                <datalist id="cars">
                                    <option v-for="(systemName, index) in systemNameOptions" :key="index">
                                        {{systemName}}
                                    </option>
                                </datalist>
                            </div>
                            <div class="col-12 col-md-6 col-lg mb-3 mb-lg-0">
                                <b-form-input :placeholder="$t('Diameter')"
                                                v-model="innerToothOptions.diameter" type="number"></b-form-input>
                            </div>
                            <div class="col-12 col-md ">
                                <b-form-input :placeholder="$t('Abutment type')"
                                                v-model="innerToothOptions.abutmentType" type="text"
                                                list="abutment"></b-form-input>
                                <datalist id="abutment">
                                    <option v-for="(option, index) in abutmentTypeOptions" :key="index">
                                        {{option}}
                                    </option>
                                </datalist>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        {{$t('Frame')}}
                    </div>
                    <div class="card-body">
                        <frame-select v-model="innerToothOptions.frame" width="35px"
                                        height="35px"></frame-select>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        {{$t('When there is not enough space')}}
                    </div>
                    <div class="card-body">
                        <b-form-radio-group
                            v-model="innerToothOptions.notEnoughSpace"
                            :options="notEnoughSpaceOptions"
                        ></b-form-radio-group>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        {{$t('Shoulder')}}
                    </div>
                    <div class="card-body">
                        <shoulder :tooltip="true" v-model="innerToothOptions.shoulder" width="40px"
                                    height="40px"></shoulder>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="card">
                    <div class="card-header">
                        {{$t('Shape and color')}}
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 face-shape--parent">
                                <label class="mr-4">{{$t('Face shape')}}</label>
                                <div class="face-shape">
                                    <div class="face-shape__item"
                                            v-for="(item, index) in faceShapeOptions"
                                            @click="faceShapeHandler(item.value)"
                                            :class="innerData.faceShape === item.value ? `${item.value} active`: `${item.value}`"
                                            :key="index">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <hr class="pt-2 pb-2">
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 col-lg">
                                        <b-input v-model="innerToothOptions.colorStump" class="mb-2" :placeholder="$t('The color of the stump')"></b-input>
                                    </div>
                                    <div class="col-12 col-lg">
                                        <b-input v-model="innerToothOptions.colorMainTeeth" class="mb-2" :placeholder="$t('The main color of the tooth')"></b-input>
                                    </div>
                                    <div class="col-12 col-lg">
                                        <b-input v-model="innerToothOptions.colorGums" :placeholder="$t('The color of the gums')"></b-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        {{$t('Design of intermediate part')}}
                    </div>
                    <div class="card-body">
                        <intermediate v-model="innerToothOptions.intermediate" width="40px"
                                        height="40px"></intermediate>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        {{$t('Paint restoration')}}
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <b-form-group class="mt-2 mb-0">
                                    <b-form-radio-group v-model="innerToothOptions.paintOption"
                                                        :options="paintOptions">
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        {{$t('Other')}}
                    </div>
                    <div class="card-body">
                        <b-form-group :label="$t('Temporary restoration')">
                            <b-input-group>
                                <b-form-select v-model.trim="innerToothOptions.temporaryRestoration"
                                                :options="restorationOptions">
                                </b-form-select>
                                <b-input-group-append v-if="innerToothOptions.temporaryRestoration">
                                    <b-button @click="innerToothOptions.temporaryRestoration=null" variant="white">
                                        <i style="line-height: 0" class="fe fe-x"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group :label="$t('In the missing tooth area')">
                            <b-form-input v-model="innerToothOptions.missingTooth"></b-form-input>
                        </b-form-group>
                        <b-form-group :label="$t('Form an ovoid impression on the model')" class="m-0">
                            <b-form-input type="number" v-model="innerToothOptions.ovoidImpression"
                                            :placeholder="$t('mm')"></b-form-input>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Shoulder from "@/components/Lab/Shoulder/ShoulderSelect";
import FrameSelect from "@/components/Lab/Frame/FrameSelect";
import Intermediate from "@/components/Lab/Intermediate/IntermediateSelect";

export default {
    name: "AdvancedBlock",
    props: {
        value: { type: Object, default: () => ({}) },
        data: { type: Object, default: () => ({}) },
    },
    components: {
        Shoulder,
        FrameSelect,
        Intermediate,
    },
    data() {
        return {
            faceShapeOptions: [
                { text: this.$t('Rectangular'), value: 'rectangular' },
                { text: this.$t('Triangular'), value: 'triangular' },
                { text: this.$t('Oval'), value: 'oval' }],
            notEnoughSpaceOptions: [
                { text: this.$t('Grind the antagonist tooth'), value: 'Grind the antagonist tooth' },
                { text: this.$t('Make a metal occlusal surface'), value: 'Make a metal occlusal surface' },],
            paintOptions: [
                { value: 'no', text: this.$t('No') },
                { value: 'weak', text: this.$t('Weak') },
                { value: 'moderately', text: this.$t('Moderately') }],
            restorationOptions: [
                { value: 'joined', text: this.$t('Joined') },
                { value: 'implant cemented', text: this.$t('Implant cemented') },
                { value: 'single', text: this.$t('Single') },
                { value: 'screw fixed', text: this.$t('Screw fixed') },
                { value: 'reinforced', text: this.$t('Reinforced') }],
            implantCrownOptions: [
                { value: 'cemented', text: this.$t("Cemented") },
                { value: 'screw fixed', text: this.$t('Screw fixed') }],
            systemNameOptions: [
                'Osstem',
                'Dentium',
                'NeoBiotech',
                'Straumann',
                'Inno',
                'Dio',
                'Nobel Biocare',
                'Alpha Dent',
                'AnyRidge',
                'AlphaBio',
                'MIS',
                'Biohorizons',
                'Impro',
                'Xive',
                'Astra Tech',
                'Bauer\'s\'',
            ],
            abutmentTypeOptions: [
                this.$t('Straight abutment'),
                this.$t('Corner abutment'),
                this.$t('Cast abutment'),
                this.$t('Premill'),
                this.$t('Temporary abutment'),
                this.$t('Temporary abutment on multiunit'),
                this.$t('Cast abutment on multiunit'),
            ],
        }
    },
    methods: {
        faceShapeHandler(value) {
            if (!this.innerData.faceShape)
                this.$set(this.innerData, 'faceShape', null)
            this.innerData.faceShape = this.innerData.faceShape === value ? null : value
        }
    },
    computed: {
        innerToothOptions: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
                this.$emit('change', value)
            }
        },
        innerData: {
            get() {
                return this.data
            },
            set(value) {
                this.$emit('update:data', value)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.face-shape {
    &--parent {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    &__item {
        display: inline-block;
        width: 40px;
        height: 40px;
        margin: 0 15px;
        cursor: pointer;

        &.rectangular {
            border: 2px solid transparent;
            background: #cce8ff;
        }

        &.triangular {
            position: relative;
            width: 0;
            height: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid transparent;
            border-bottom: 40px solid #cce8ff;

            &:after {
                content: '';
                position: absolute;
                top: 5px;
                left: -16px;
                width: 0;
                height: 0;
                border-left: 16px solid transparent;
                border-right: 16px solid transparent;
                border-bottom: 33px solid #cce8ff;
            }
        }

        &.oval {
            border: 2px solid transparent;
            border-radius: 50%;
            background: #cce8ff;
        }

        &:first-child {
            margin-left: 0;
        }

        &:last-child {
            margin-right: 0;
        }

        &:hover,
        &.active {
            &.rectangular, &.oval {
                border-color: #99d1ff;
            }

            &.triangular {
                border-bottom-color: #99d1ff;
            }
        }
    }
}
</style>
